/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ws_Continue_TitleInputs */

const en_ws_continue_title = /** @type {(inputs: Ws_Continue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick up where you left off`)
};

const id_ws_continue_title = /** @type {(inputs: Ws_Continue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjutkan yang tadi`)
};

/**
* | output |
* | --- |
* | "Pick up where you left off" |
*
* @param {Ws_Continue_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const ws_continue_title = /** @type {((inputs?: Ws_Continue_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Continue_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ws_continue_title(inputs)
	return en_ws_continue_title(inputs)
});